/**
 * Scroll-spy: given the rendered anchor elements (in document order), the scroll
 * container's visible top, and an offset, return the id of the last anchor whose
 * top has scrolled above `containerTop + offset` — i.e. the anchor currently at
 * the top of the viewport. Falls back to the first anchor when none have
 * scrolled past yet, and null when there are no anchors.
 */
export function activeAnchorOnScroll(
  anchorEls: HTMLElement[],
  containerTop: number,
  offset: number,
): string | null {
  if (anchorEls.length === 0) return null;
  const threshold = containerTop + offset;
  let current: string | null = null;
  for (const el of anchorEls) {
    if (el.getBoundingClientRect().top - threshold <= 0) {
      current = el.getAttribute('data-anchor-id');
    }
  }
  return current ?? anchorEls[0].getAttribute('data-anchor-id');
}
